import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import login from '@/views/login/index'
import listOfExpenses from '@/views/order/index'
import rechargeList from '@/views/order/rechargeList'
import consumptionList from '@/views/order/consumptionList'
import consumptionDesc from '@/views/order/consumptionDesc'
import rechargeCallsCost from '@/views/order/rechargeCallsCost'
import rechargeConversation from '@/views/order/rechargeConversation'
import rechargeHeGetCustomer from '@/views/order/rechargeHeGetCustomer'
import rechargeManagementArtifact from '@/views/order/rechargeManagementArtifact'
import seatList from '@/views/order/seatList'
import recharge from '@/views/order/recharge'
import newRecharge from '@/views/order/newRecharge'
import clueDesc from '@/views/clue/index'
import clueList from '@/views/clue/list'
import bind from '@/views/bind/index'
import taskList from '@/views/task/taskList'
import survey from '@/views/survey/index'
import PrivacyAgreement from '../views/agreement/privacyAgreement.vue';
import UserAgreement from '../views/agreement/userAgreement.vue';
import download from '../views/download/index.vue';
import downloadplus from '../views/download/plus.vue';
import TelemarketingGuard from '../views/app/TelemarketingGuard'
import TelemarketingGuardList from '../views/app/TelemarketingGuardList'
import dataStatistics from '../views/app/dataStatistics'
import help from '../views/app/help.vue'
// register
import registerApply from '../views/register/registerApply'
import apply from '../views/apply/index.vue'
import share from '../views/apply/share.vue'
import servics from '../views/servics/index.vue'
import trial from '../views/trial/index.vue'


Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'index',
			component: index ,
		

		},
		{
			path: '/login',
			name: 'login',
			component: login,
			meta: {
				isLogin: false,
			}
		},
		{
			path: '/apply',
			name: 'apply',
			component: apply,
			meta: {
				isLogin: true,
			}
		},
		{
			path: '/share',
			name: 'share',
			component: share,
			meta: {
				isLogin: false,
			}
		},
		{
			path: '/registerApply',
			name: 'registerApply',
			component: registerApply,
			meta: {
				isLogin: false,
			}
		},
		{
			path: '/download',
			name: 'download',
			component: download,
			meta: {
				isLogin: false,
			}
		},
		{
			path: '/downloadplus',
			name: 'downloadplus',
			component: downloadplus,
			meta: {
				isLogin: false,
			}
		},
		{
			path: '/PrivacyAgreement',
			name: 'PrivacyAgreement',
			component: PrivacyAgreement,
			meta: {
				isLogin: false,
			}
		},
		{
			path: '/UserAgreement',
			name: 'UserAgreement',
			component: UserAgreement,
			meta: {
				isLogin: false,
			}
		},
		{
			path: '/TelemarketingGuard',
			name: 'TelemarketingGuard',
			component: TelemarketingGuard,
			meta: {
				isLogin: false,
			}
		},
		{
			path: '/TelemarketingGuardList',
			name: 'TelemarketingGuardList',
			component: TelemarketingGuardList,
			meta: {
				isLogin: false,
			}
		},
		{
			path: '/dataStatistics',
			name: 'dataStatistics',
			component: dataStatistics,
			meta: {
				isLogin: false,
			}
		},
		{
			path: '/help',
			name: 'help',
			component: help,
			meta: {
				isLogin: false,
			}
		},
		{
			path: '/listOfExpenses',
			name: 'listOfExpenses',
			component: listOfExpenses,
			meta: {
				isLogin: true,
			}
		},
		{
			path: '/rechargeList',
			name: 'rechargeList',
			component: rechargeList,
			meta: {
				isLogin: true,
			}
		},
		{
			path: '/seatList',
			name: 'seatList',
			component: seatList,
			meta: {
				isLogin: true,
			}
		},
		{
			path: '/consumptionList',
			name: 'consumptionList',
			component: consumptionList,
			meta: {
				isLogin: true,
			}
		},
		{
			path: '/consumptionDesc',
			name: 'consumptionDesc',
			component: consumptionDesc,
			meta: {
				isLogin: true,
			}
		},
		{
			path: '/rechargeCallsCost',
			name: 'rechargeCallsCost',
			component: rechargeCallsCost,
			meta: {
				isLogin: true,
			}
		},
		{
			path: '/rechargeConversation',
			name: 'rechargeConversation',
			component: rechargeConversation,
			meta: {
				isLogin: true,
			}
		},
		{
			path: '/rechargeHeGetCustomer',
			name: 'rechargeHeGetCustomer',
			component: rechargeHeGetCustomer,
			meta: {
				isLogin: true,
			}
		},
		{
			path: '/rechargeManagementArtifact',
			name: 'rechargeManagementArtifact',
			component: rechargeManagementArtifact,
			meta: {
				isLogin: true,
			}
		},
		{
			path: '/recharge',
			name: 'recharge',
			component: recharge,
			meta: {
				isLogin: true,
			}
		},
		{
			path: '/newRecharge',
			name: 'newRecharge',
			component: newRecharge,
			meta: {
				isLogin: true,
				// isLogin: false,
			}
		},
		{
			path: '/clueDesc',
			name: 'clueDesc',
			component: clueDesc,
			meta: {
				isLogin: true,
			}
		},
		{
			path: '/clueList',
			name: 'clueList',
			component: clueList,
			meta: {
				isLogin: true,
			}
		},
		{
			path: '/bind',
			name: 'bind',
			component: bind,
			meta: {
				isLogin: true,
				// isLogin: false,
			}
		},
		{
			path: '/taskList',
			name: 'taskList',
			component: taskList,
			meta: {
				isLogin: true,
			}
		},
		{
			path: '/survey',
			name: 'survey',
			component: survey,
			meta: {
				isLogin: true,
				// isLogin: false,
			}
		},
		{
			path: '/servics',
			name: 'servics',
			component: servics,
			meta: {
				isLogin: false,
			}
		},
		{
			path: '/trial',
			name: 'trial',
			component: trial,
			meta: {
				isLogin: false,
			}
		},
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js



// WEBPACK FOOTER //
// ./src/router/index.js